import { Component, OnInit } from '@angular/core';
import { TopnavLayoutConfig } from './_models/topnav-layout-config.model';
import { ActivatedRoute } from '@angular/router';

/**
 * The topnav layout container component
 */
@Component({
  selector: 'lm-topnav-layout-container',
  templateUrl: './topnav-layout.component.html',
  styleUrls: ['./topnav-layout.component.scss']
})
export class TopnavLayoutComponent implements OnInit {
  /** The topnav layout config object */
  public layoutConfig: TopnavLayoutConfig;

  /** Boolean indicating whether the component is initialized */
  public initialized = false;

  /**
   * @param route - The activated route
   */
  constructor(private route: ActivatedRoute) {}

  /**
   * Method called when the component is initialized
   */
  public ngOnInit() {
    this.route.data.subscribe((data: TopnavLayoutConfig) => {
      this.layoutConfig = data;
      this.initialized = true;
    });
  }
}
